var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { CollectionCard } from './collection-card';
import { CollectionGroup } from './collection-group';
import { cs, getCollectionGroups, isSubArray, retrieveBlocks } from '../utils';
import { EmptyIcon } from '../icons/empty-icon';
import { Property } from './property';
import { useNotionContext } from '../context';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
export var CollectionViewBoard = function (_a) {
    var _b;
    var collection = _a.collection, collectionView = _a.collectionView, collectionData = _a.collectionData, padding = _a.padding;
    var isGroupedCollection = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by;
    if (isGroupedCollection) {
        var collectionGroups = getCollectionGroups(collection, collectionView, collectionData, padding);
        if (collectionGroups.length == 0) {
            collectionGroups = Object.keys(collectionData)
                .filter(function (key) { return key.indexOf('results:') != -1; })
                .map(function (key) { return collectionData[key]; });
        }
        return collectionGroups === null || collectionGroups === void 0 ? void 0 : collectionGroups.map(function (group, index) { return (React.createElement(CollectionGroup, __assign({ key: index }, group, { summaryProps: {
                style: {
                    paddingLeft: padding
                }
            }, collectionViewComponent: function (props) { return (React.createElement(Board, __assign({ padding: padding }, props, { index: index, collectionGroup: group }))); } }))); });
    }
    return (React.createElement(Board, { collectionView: collectionView, collection: collection, collectionData: collectionData }));
};
function Board(_a) {
    var _b, _c;
    var collectionView = _a.collectionView, collectionData = _a.collectionData, collection = _a.collection, _d = _a.collectionGroup, collectionGroup = _d === void 0 ? null : _d, _e = _a.index, index = _e === void 0 ? 0 : _e;
    var recordMap = useNotionContext().recordMap;
    var retrieveMissingImageBlocks = UseRetrieveBlocks().retrieveMissingImageBlocks;
    var _f = useState({}), imageBlocks = _f[0], setImageBlocks = _f[1];
    var _g = (collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) || {}, _h = _g.board_cover, board_cover = _h === void 0 ? { type: 'none' } : _h, _j = _g.board_cover_size, board_cover_size = _j === void 0 ? 'medium' : _j, _k = _g.board_cover_aspect, board_cover_aspect = _k === void 0 ? 'cover' : _k;
    var boardGroups = ((_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.board_columns) ||
        ((_c = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _c === void 0 ? void 0 : _c.board_groups2) ||
        [];
    return (React.createElement("div", { className: 'notion-board' },
        React.createElement("div", { className: cs('notion-board-view', "notion-board-view-size-".concat(board_cover_size)) },
            index == 0 && (React.createElement("div", { className: 'notion-board-header' },
                React.createElement("div", { className: 'notion-board-header-inner' }, boardGroups.map(function (p, i) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    var groupValue, group, schema;
                    if ((_a = collectionData.board_columns) === null || _a === void 0 ? void 0 : _a.results) {
                        group = collectionData.board_columns.results[i];
                        schema = collection.schema[p.property];
                        if (group.value.type == 'relation') {
                            var relationId = (_b = group.value.value) === null || _b === void 0 ? void 0 : _b.id;
                            if (relationId) {
                                var relation = (_c = recordMap.block[relationId]) === null || _c === void 0 ? void 0 : _c.value;
                                if (relation)
                                    groupValue = (_e = (_d = relation.properties.title) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e[0];
                            }
                        }
                        else {
                            groupValue = (_f = group.value) === null || _f === void 0 ? void 0 : _f.value;
                        }
                    }
                    else if (collectionData.collection_group_results) {
                        var blockIds = retrieveBlocks(collection, collectionView, collectionData, recordMap);
                        blockIds = applyBoardFilter(recordMap, collection, collectionGroup, p, index, blockIds, schema);
                        schema = schema || collection.schema;
                        var property = schema === null || schema === void 0 ? void 0 : schema[p.property];
                        if (property && property.type == 'select')
                            groupValue = (_h = (_g = property === null || property === void 0 ? void 0 : property.options) === null || _g === void 0 ? void 0 : _g[i]) === null || _h === void 0 ? void 0 : _h.value;
                        group = { total: blockIds.length };
                    }
                    else {
                        return null;
                    }
                    if (!group || !schema || (p.hidden && !groupValue))
                        return null;
                    return (React.createElement("div", { className: 'notion-board-th', key: i },
                        React.createElement("div", { className: 'notion-board-th-body' },
                            groupValue ? (React.createElement(Property, { schema: schema, data: [
                                    [(groupValue === null || groupValue === void 0 ? void 0 : groupValue.group) ? groupValue.group : groupValue]
                                ], collection: collection })) : (React.createElement("span", null,
                                React.createElement(EmptyIcon, { className: 'notion-board-th-empty' }),
                                " No Select")),
                            React.createElement("span", { className: 'notion-board-th-count' }, group.total))));
                })))),
            React.createElement("div", { className: 'notion-board-header-placeholder' }),
            React.createElement("div", { className: 'notion-board-body' }, boardGroups.map(function (p, index) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (!((_a = collectionData.board_columns) === null || _a === void 0 ? void 0 : _a.results) &&
                    !collectionData.collection_group_results) {
                    return null;
                }
                var currentGroup = collectionData.board_columns.results[index];
                var blockIds = [];
                var group = {};
                if (collectionView.format.board_columns_by.type == 'relation') {
                    if ((_c = (_b = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.value) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.id) {
                        var relationId_1 = currentGroup.value.value.id;
                        var resultId = Object.keys(collectionData).find(function (key) {
                            return key.indexOf('results:') != -1 &&
                                key.indexOf(relationId_1) != -1;
                        });
                        if (resultId)
                            blockIds = ((_d = collectionData[resultId]) === null || _d === void 0 ? void 0 : _d.blockIds) || [];
                    }
                    else {
                        var resultId = Object.keys(collectionData).find(function (key) { return key.indexOf('uncategorized') != -1; });
                        if (resultId)
                            blockIds = ((_e = collectionData[resultId]) === null || _e === void 0 ? void 0 : _e.blockIds) || [];
                    }
                }
                else {
                    var schema = collection.schema[p.property];
                    group = collectionData["results:select:".concat(((_f = p === null || p === void 0 ? void 0 : p.value) === null || _f === void 0 ? void 0 : _f.value) || 'uncategorized')];
                    group =
                        group ||
                            collectionData["results:".concat(p.value.type, ":").concat('by_group-' + ((_h = (_g = p === null || p === void 0 ? void 0 : p.value) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.group) || 'uncategorized')];
                    blockIds =
                        (group === null || group === void 0 ? void 0 : group.blockIds) ||
                            retrieveBlocks(collection, collectionView, collectionData, recordMap);
                    blockIds = applyBoardFilter(recordMap, collection, collectionGroup, p, index, blockIds, schema);
                    if (!schema || p.hidden)
                        return null;
                    if (blockIds.length > 0 &&
                        (board_cover === null || board_cover === void 0 ? void 0 : board_cover.type) === 'page_content' &&
                        Object.keys(imageBlocks).length == 0) {
                        retrieveMissingImageBlocks(blockIds, board_cover).then(function (pictureBlocks) {
                            if (pictureBlocks)
                                setImageBlocks(function (blocks) { return (__assign(__assign({}, blocks), pictureBlocks)); });
                        });
                    }
                }
                return (React.createElement("div", { className: 'notion-board-group', key: index }, blockIds.map(function (blockId) {
                    var _a, _b;
                    var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                    if (!block)
                        return null;
                    return (React.createElement(CollectionCard, { className: 'notion-board-group-card', collection: collection, block: block, cover: board_cover, imageBlock: imageBlocks[block.id], coverSize: board_cover_size, coverAspect: board_cover_aspect, properties: (_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.board_properties, key: blockId }));
                })));
            })))));
}
function applyBoardFilter(recordMap, collection, collectionGroup, p, index, blockIds, schema) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (collectionGroup) {
        var collectionSchema = collection.schema;
        var sectionField_1 = (_a = Object.entries(collectionSchema).find(function (s) { var _a; return ((_a = s[1]) === null || _a === void 0 ? void 0 : _a.name) == collectionGroup.schema.name; })) === null || _a === void 0 ? void 0 : _a[0];
        var groupField_1 = p.property;
        var groups = ((_c = (_b = collectionSchema[groupField_1]) === null || _b === void 0 ? void 0 : _b.groups) === null || _c === void 0 ? void 0 : _c.map(function (g) { return g.name; })) || [];
        var options = ((_e = (_d = collectionSchema[groupField_1]) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.map(function (o) { return o.value; })) || [];
        var mOptions_1 = [groups[index]];
        if (options.length > 0)
            mOptions_1 = [options[index], groups[index]];
        var sectionValue_1 = collectionGroup.value;
        return blockIds.filter(function (blockId) {
            var _a, _b, _c, _d, _e;
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            var f_value = ((_c = (_b = block.properties[sectionField_1]) === null || _b === void 0 ? void 0 : _b.flat()) === null || _c === void 0 ? void 0 : _c.flat()) || [];
            var g_value = ((_e = (_d = block.properties[groupField_1]) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e.flat()) || [
                schema.defaultOption
            ];
            return (f_value === null || f_value === void 0 ? void 0 : f_value.includes(sectionValue_1)) && isSubArray(mOptions_1, g_value);
        });
    }
    else if (collection === null || collection === void 0 ? void 0 : collection.schema) {
        var collectionSchema = collection.schema;
        var sectionField_2 = p.property;
        var sectionValue_2 = (_f = p === null || p === void 0 ? void 0 : p.value) === null || _f === void 0 ? void 0 : _f.value;
        var groups = ((_h = (_g = collectionSchema[sectionField_2]) === null || _g === void 0 ? void 0 : _g.groups) === null || _h === void 0 ? void 0 : _h.map(function (g) { return g.name; })) || [];
        var options = ((_k = (_j = collectionSchema[sectionField_2]) === null || _j === void 0 ? void 0 : _j.options) === null || _k === void 0 ? void 0 : _k.map(function (o) { return o.value; })) || [];
        var mOptions_2 = [
            sectionValue_2,
            options[groups.findIndex(function (f) { return f == sectionValue_2; })] || ''
        ];
        if (!mOptions_2.every(function (o) { return typeof o !== 'object'; }))
            return blockIds;
        return blockIds.filter(function (blockId) {
            var _a, _b, _c, _d;
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            var f_value = ((_d = (_c = (_b = block.properties) === null || _b === void 0 ? void 0 : _b[sectionField_2]) === null || _c === void 0 ? void 0 : _c.flat()) === null || _d === void 0 ? void 0 : _d.flat()) || [];
            return isSubArray(mOptions_2, f_value);
        });
    }
    return blockIds;
}
//# sourceMappingURL=collection-view-board.js.map